const NoActivityData = (): JSX.Element => {
    return (
        <div className="activity-area-ss">
    <ul className="list">        
        <li className="transaction-info-trx">
            <p className="body-s fw-b n-gray">거래 기록이 없습니다.</p>
        </li>
    </ul>
</div>
    )
}

export default NoActivityData;